function ThankYou() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-gradient-to-br from-indigo-100 via-white to-slate-100 px-4 py-10">
      <section className="w-full max-w-xl rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-xl shadow-indigo-100/40">
        <img
          src="/logo-rcare.png"
          alt="Rheumatology Care of Georgia"
          className="mx-auto mb-6 h-16 w-auto sm:h-20"
        />
        <h1 className="text-3xl font-bold tracking-tight text-slate-900">Thank you for your payment!</h1>
        <p className="mt-3 text-sm text-slate-600">
          Your transaction has been received successfully. A confirmation will be shared with you shortly.
        </p>
      </section>
    </main>
  );
}

export default ThankYou;
